import React from 'react'
import Footer from './Footer'

function More() {
    return (
        <div className='more'>
            <div className="other_overlay"></div>
            <div className="more_container">
                <div className="more_content">
                    <h2>
                        We proffer Customise Group functions.
                    </h2>
                    <div className="selections">
                        <select name="event" id="event">
                            <option value="wedding"> </option>
                            <option value="conference">Conference</option>
                            <option value="meetings">Association</option>
                            <option value="sport">Stag or Hen party</option>
                            <option value="sport">Business Meeting</option> 
                            <option value="sport">Bus Tour</option>
                            <option value="sport">Charity Event</option>
                            <option value="sport">Class Reunions</option>
                            <option value="sport">Convention</option>
                            <option value="sport">Societies and Alumni</option>
                            <option value="sport">Millitary</option>
                            <option value="sport">Music Bands</option>
                        </select>
                    </div>
                </div>
            </div>
            <Footer />

        </div>
    )
}

export default More
